export default __webpack_public_path__ + "static/media/single-campaign.130e48e7.png";